import ErrorIcon from '@mui/icons-material/ErrorOutline'
import { RangeFilter } from 'interfaces'
import { STOCK_ALL_FILTER } from 'interfaces/Content/StockContentTypes'
import { memo, type ReactNode, useLayoutEffect, useState } from 'react'
import { MessageDescriptor } from 'react-intl'

export const NO_CONTENT_MESSAGE = (
  type: FilterType,
  isStream: boolean | undefined,
  formatMessage: (descriptor: MessageDescriptor, values?: any) => string,
  range?: RangeFilter
) => {
  if (isStream && range === 'new') {
    return formatMessage({ id: 'content.msg.stream-range-new-title' })
  }
  let contentType = formatMessage({ id: `general.content.filters.${type}` })
  if (type === STOCK_ALL_FILTER) {
    contentType = formatMessage({ id: 'general.labels.stock-content-items' })
  }
  return formatMessage({ id: `content.msg-no-content${isStream ? '-stream' : ''}` }, { contentType })
}

export const NO_CONTENT_POPULAR_MESSAGE = (type: FilterType, formatMessage: (descriptor: MessageDescriptor, values?: any) => string) => {
  const contentType = formatMessage({ id: `general.content.filters.${type}` })
  return formatMessage({ id: 'content.msg-no-content-curated' }, { contentType })
}

export const AJAX_ERROR_FEED_NOT_FOUND = (formatMessage: (descriptor: MessageDescriptor, values?: any) => string) => {
  return formatMessage({ id: 'content.error.feed-not-found' })
}

export const AJAX_ERROR_FEED_NOT_FOUND_SUBTITLE = (formatMessage: (descriptor: MessageDescriptor, values?: any) => string) => {
  return formatMessage({ id: 'content.error.feed-not-found-subtitle' })
}

export const AJAX_ERROR_STREAM_NOT_FOUND = (formatMessage: (descriptor: MessageDescriptor, values?: any) => string) => {
  return formatMessage({ id: 'content.error.stream-not-found' })
}

export const AJAX_ERROR_STREAM_NOT_FOUND_SUBTITLE = (formatMessage: (descriptor: MessageDescriptor, values?: any) => string) => {
  return formatMessage({ id: 'content.error.stream-not-found-subtitle' })
}

export const AJAX_ERROR_POPULAR_MESSAGE = (formatMessage: (descriptor: MessageDescriptor, values?: any) => string) => {
  return formatMessage({ id: 'content.error.curated-stream' })
}

export const AJAX_ERROR_STREAM_SUBTITLE = (formatMessage: (descriptor: MessageDescriptor, values?: any) => string) => {
  return formatMessage({ id: 'content.error.curated-stream-subtitle' })
}

export const NO_CONTENT_MESSAGE_CAROUSEL = (type: FilterType, formatMessage: (descriptor: MessageDescriptor, values?: any) => string) => {
  let contentType = formatMessage({ id: `general.content.filters.${type}` })
  if (type === STOCK_ALL_FILTER) {
    contentType = formatMessage({ id: 'general.labels.stock-content-items' })
  }
  return formatMessage({ id: 'content.msg.carousel.empty-type' }, { contentType })
}

export const NO_CONTENT_MESSAGE_FAVORITES = (type: FilterType, formatMessage: (descriptor: MessageDescriptor, values?: any) => string) => {
  const contentType = formatMessage({ id: `general.content.filters.${type}` })
  return formatMessage({ id: 'content.msg.carousel.favorites-empty' }, { contentType })
}

export const PROFILES_NOT_CONNECTED_MESSAGE = (formatMessage: (descriptor: MessageDescriptor, values?: any) => string) => {
  return formatMessage({ id: 'content.error.profiles-not-connected' })
}

import styles from './ErrorOverlay.pcss'
import { FilterType } from 'shared'

export interface ErrorOverlayProps {
  error: string
  subtitle: string
  subtitleElement?: ReactNode
  originalError: any
  className?: string
  offset?: number
  contentType?: string
  small?: boolean
}

export function ErrorOverlay(props: ErrorOverlayProps) {
  const { error, subtitle, subtitleElement, originalError, offset, contentType, small } = props
  const [animate, setAnimate] = useState<boolean>(false)

  useLayoutEffect(() => {
    setAnimate(true)
  }, [])

  const minOffset = 40
  const style = typeof offset === 'undefined'
    ? {}
    : { top: `${offset === 0 ? minOffset : offset}px` }

  const className = `${styles.error} ${animate ? styles.animate : ''} ${props.className || ''} ${small ? styles.small : ''}`
  const messageClassName = `${styles.message} ${contentType ? (styles as any)[contentType] : ''}`

  return (
    <div className={className} style={style} data-testid="error-box">
      <div className={messageClassName}>
        <span className={styles['content-icon']} />
        {!contentType && <ErrorIcon className={styles.icon} />}
        <h3 title={originalError}>{error}</h3>
        <span className={styles.subtitle}>
          {subtitle}
          {subtitleElement || null}
        </span>
      </div>
    </div>
  )
}

export default memo(ErrorOverlay)
